import React from "react";
import CertExcel1 from '../assets/images/cert1.jpg';
import CertExcel2 from '../assets/images/cert2.jpg';
import CertExcel3 from '../assets/images/cert3.jpg';
import '../assets/styles/Certificates.scss';

interface CertificateItem {
  title: string;
  issuer: string;
  date: string;
  image: string;
  credentialUrl?: string;
}

// TODO: replace with real data — import your certificate images the same way
// Project.tsx imports mock01, mock02, etc, then reference them in "image" below.
const certificateData: CertificateItem[] = [
  {
    title: "Certificate Jago Microsoft Excel",
    issuer: "Skill Academy By Ruangguru",
    date: " 12 Juli 2026",
    image: CertExcel1,
    credentialUrl: "https://skillacademy.com/sertifikat/57ZWLRMFVKCITP",
  },
  {
    title: "Certificate Ahli Mengolah Data dengan Microsoft Excel",
    issuer: "Skill Academy By Ruangguru",
    date: " 23 Juli 2026",
    image: CertExcel2,
    credentialUrl: "https://skillacademy.com/sertifikat/1J4SFLTRUATI33",
  },
  {
    title: "Certificate Mahir Menggunakan Microsoft Excel",
    issuer: "Skill Academy By Ruangguru",
    date: " 23 Juli 2026",
    image: CertExcel3,
    credentialUrl: "https://skillacademy.com/sertifikat/8L6G8HSDHE3BBO",
  }
];

function Certificates() {
  return (
    <div className="certificates-container" id="certificates">
      <h1>Certificates</h1>
      <div className="certificates-grid">
        {certificateData.map((cert, index) => (
          <div className="certificate" key={`${cert.title}-${index}`}>
            <a href={cert.credentialUrl || "#"} target="_blank" rel="noreferrer">
              <img src={cert.image} className="zoom" alt={cert.title} width="100%" />
            </a>
            <a href={cert.credentialUrl || "#"} target="_blank" rel="noreferrer">
              <h2>{cert.title}</h2>
            </a>
            <p>{cert.issuer} — {cert.date}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Certificates;
